import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	PageFeatureConfigSymbol,
	ComponentsStylesOverridesSymbol,
	IComponentsStylesOverrides,
	IPageDidMountHandler,
	BrowserWindow,
	BrowserWindowSymbol,
} from '@wix/thunderbolt-symbols'
import fastdom from 'fastdom'
import type { HeaderContainerPageConfig } from './types'
import { name } from './symbols'

const headerContainerFactory = (
	{ componentId, marginTop }: HeaderContainerPageConfig,
	componentsStylesOverrides: IComponentsStylesOverrides,
	window: BrowserWindow
): IPageDidMountHandler => {
	const overrideFixedHeaderWhenTooHigh = () =>
		fastdom.measure(() => {
			const headerHeight = window!.document.getElementById(componentId)?.clientHeight || 0
			const isTooHighToBeFixedOnMobile = headerHeight >= window!.document.body.clientHeight / 2
			if (isTooHighToBeFixedOnMobile) {
				componentsStylesOverrides.update({
					[componentId]: {
						position: 'relative !important' as const,
						'margin-top': `${marginTop}px`,
						top: '0',
					},
				})
			}
		})

	return {
		pageDidMount: overrideFixedHeaderWhenTooHigh,
	}
}

export const HeaderContainer = withDependencies(
	[named(PageFeatureConfigSymbol, name), named(ComponentsStylesOverridesSymbol, name), BrowserWindowSymbol],
	headerContainerFactory
)
